import { toggleNav } from '../../js/main'
import '../../css/reset.css'
import '../../css/constants.css'
import '../../css/main.css'
import '../../css/inhouse-product-common.css'
import './inline-mixer.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import './inline-mixer-three-animation-setup'


gsap.registerPlugin(ScrollTrigger)
gsap.set(document.querySelector('body'), {
    visibility: 'visible'
})
window.addEventListener('load', () => {
    // console.log('load')
    ScrollTrigger.refresh()
})
toggleNav()
// entry()
console.log('this is static inline mixing');